import {useMemo, useState} from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';
import AuxiliarFunction from '../../function/AuxiliarFunction';

function getOptionSelect(value,options){
    if(!Array.isArray(options)){
        return null;
    }
    if(AuxiliarFunction.isObject(value)){
        return value;
    }
    const option = options.find(opt => opt.value === value);
    if(option){
        return option;
    }
    return null;
}

const Select = ({
    id,
    options,
    defaultValue: externalDefaultValue,
    onChange,
    isInvalid,
    isClearable
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [defaultValue, setDefaultValue] = useState(getOptionSelect(externalDefaultValue,options));
    const onSelectValue = (ev) => {
        onChange(ev);
    };
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : isDarkMode ? '#e0e0e0' : '#000',
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none',
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    return (
        <ReactSelect
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            defaultValue={defaultValue}
            onChange={onSelectValue}
            isClearable={isClearable}
        />
    );
};

Select.propTypes = {
    isClearable: PropTypes.bool,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
        })
    ),
};

Select.defaultProps = {
    isClearable: false,
    options: [],
};

export default Select;
